module.exports = __webpack_public_path__ + "static/media/detail_0056_t.28add944.jpg";